import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Line } from './Line'
import { Status } from './Status'

import Text from './Text'
import SugestionLine from './SugestionLine'
import { beautify } from '@util/recommendationBeautifier'

import { statusByIcon } from '@util/recommendationToHtmlUtil'

const styles = {
  title: {
    fontSize: 14,
    marginLeft: 8,
    fontFamily: 'Inter-Bold',
  },
  view: {},
  exclamationMark: {
    backgroundColor: '#E13A331A',
    borderRadius: '50%',
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  line: {
    marginBottom: 16,
  },
}

export const ActionTitle = ({ titleColor, titleText, recommendations }) => (
  <>
    <div style={styles.container}>
      <Status
        text="!"
        textColor={titleColor}
        textStyle={{ fontSize: 12 }}
        minWidth={14}
      />
      <div style={styles.view}>
        <Text style={{ ...styles.title, color: titleColor, fontWeight: 700 }}>
          {titleText}
        </Text>
      </div>
    </div>
    <Line lineColor={titleColor} style={styles.line} />
    {_.map(recommendations, ({ label, icon }) => {
      const pretty = beautify(label)
      if (!pretty) return null

      return (
        <SugestionLine
          text={pretty}
          color={titleColor}
          status={statusByIcon[icon]}
          key={label}
        />
      )
    })}
  </>
)

ActionTitle.propTypes = {
  titleColor: PropTypes.string,
  titleText: PropTypes.string.isRequired,
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      color: PropTypes.string,
      icon: PropTypes.func,
      label: PropTypes.string,
    })
  ).isRequired,
}

ActionTitle.defaultProps = {
  titleColor: null,
}
